import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import {NavLink} from 'react-router-dom';
import * as utils from './utils.js';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import {Container} from "react-bootstrap";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.sendMessage = this.sendMessage.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.contactForm = this.contactForm.bind(this);
        this.setValidated = this.setValidated.bind(this);

        this.state = {
            config: '',
            from: '',
            message: '',
            name: '',
            show: false,
            validated: false,
            apiSent: false,
            apiSuccess: false,
            apiMessage: '',
            recaptchaKey: '6LeaQkMaAAAAAAmoQG6ycrhW1JXiFQ2jetO_jc49',
        };
    }
    componentDidMount() {
        const script = document.createElement('script');
        const siteKey = this.state.recaptchaKey;
        const that = this;

        script.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey;
        script.addEventListener('load', () => {
            window.grecaptcha.ready(function () {
                window.grecaptcha
                    .execute(siteKey, {
                        action: 'homepage',
                    })
                    .then(function (token) {
                        that.setState({
                            token,
                        });
                    });
            });
        });

        document.body.appendChild(script);
    }

    handleChange(e) {
        const name = e.target.name;
        const newState = {};

        newState[name] = e.target.value;
        this.setState(newState);
    }
    showModal(){
        this.setState({show: true,});
    }
    hideModal(){
        this.setState({
            show: false,
            validated: false,
            from: '',
            message: '',
            name: '',
        });
    }
    setValidated(e){
        this.setState({validated: e,});
    }
    contactForm(){
        const handleSubmit = (event) => {
            console.log(this.state.token);
            const form = event.currentTarget;
            console.log(form.checkValidity())
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }else {
                this.sendMessage();
            }

            this.setValidated(true);
        };
        return (
            <Form noValidate validated={this.state.validated} >
                <Form.Row>
                    <Form.Group as={Col} controlId="name">
                        <Form.Label>Your name</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            placeholder=""
                            defaultValue=""
                            name="name"
                            value={this.state.name}
                            onChange={this.handleChange}
                        />
                        <Form.Control.Feedback type="invalid">Please provide your name</Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} controlId="email">
                        <Form.Label>Your email</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            placeholder=""
                            defaultValue=""
                            name="from"
                            value={this.state.from}
                            onChange={this.handleChange}
                        />
                        <Form.Control.Feedback type="invalid">Please provide your email</Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} controlId="message">
                        <Form.Label>What say you?</Form.Label>
                        <Form.Control
                            required
                            as={'textarea'}
                            placeholder=""
                            defaultValue=""
                            name="message"
                            value={this.state.message}
                            onChange={this.handleChange}
                        />
                        <Form.Control.Feedback type="invalid">Please share some information</Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
                <div className="g-recaptcha" data-sitekey={this.state.recaptchaKey} data-size="invisible" />
                <Form.Row style={{textAlign:'right',paddingTop:'1em'}}><Button onClick={this.hideModal} variant={'secondary'}>Cancel</Button>&nbsp;<Button onClick={handleSubmit}>Send!</Button></Form.Row>

            </Form>
        )
    }

    sendMessage() {
        const confirm = {
            f: 'confirm',
            from: this.state.from,
            message: this.state.message,
            recaptcha: this.state.token
        };

        utils.ApiPostRequest('https://www.pbkminibar.com/jamail.php', confirm).then((data) => {
            if (data) {
                this.setState({
                    error: data.message,
                    variantClass: data.Variant,
                });
            } else {
                this.setState({
                    error: 'Sorry, an unexpected error occurred',
                    variantClass: 'danger',
                });
            }
        });
    }

    render() {
        return (
            <Navbar expand="lg" sticky="top" collapseOnSelect className={'ja-header'}>
                <Container fluid className={'ja-header'}>
                <NavLink
                    exact
                    activeClassName="nav-item text-info"
                    activeStyle={{
                        fontWeight: "bold"
                    }}
                    style={{ color: '#4A6FA5' }}
                    className="navbar-brand"
                    to="/"
                >
                    Jonathan Arbitman
                </NavLink>
                <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav>
                        <NavLink
                            exact
                            activeClassName="nav-item text-info"
                            activeStyle={{
                                fontWeight: "bold"
                            }}
                            style={{ color: '#4A6FA5' }}
                            className="nav-link"
                            to="/work"
                        >
                            Work Experience
                        </NavLink>
                        <NavLink
                            exact
                            activeClassName="nav-item text-info"
                            activeStyle={{
                                fontWeight: "bold"
                            }}
                            style={{ color: '#4A6FA5' }}
                            className="nav-link"
                            to="/projects"
                        >
                            Projects
                        </NavLink>
                    </Nav>
                </Navbar.Collapse>
                <Modal show={this.state.show} onHide={this.hideModal}>
                    <Modal.Header>
                        <Modal.Title><h2 className={'text-info'}>Contact</h2></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.contactForm()}</Modal.Body>
                </Modal>
                </Container>
            </Navbar>
        );
    }
}

export default Header;
